import React, { Component } from 'react';
import { throttle } from 'lodash';
import classNames from 'classnames';
import { Link } from 'gatsby';

import Button from './Button';
import Burger from './Burger';

import LogoSrc from '../img/svg/logo-getindata-xebia.svg';
import LogoSignetSrc from '../img/svg/logo-signet.svg';
import IconArrowGreenDown from '../img/svg/icons/arrow-green-down.svg';

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.banner = React.createRef();
    this.state = {
      isOpen: false,
      isFloating: false,
      dropdown: {},
      isBannerOverflown: false
    };
  }

  toggleMenu = () => {
    this.setState(prev => ({ isOpen: !prev.isOpen }));
  };

  toggleDropdown = (e) => {
    const { dropdown } = this.state;
    this.setState({ dropdown: Object.assign(dropdown, { [e]: !dropdown[e] }) });
  };

  isBannerOverflown(element) {
    if (element) {
      const condition = element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
      this.setState({ isBannerOverflown: condition });
    }
  }

  get isScrolledToTop() {
    return window.scrollY === 0;
  }

  onScroll = () => {
    this.setState({ isFloating: !this.isScrolledToTop });
  };
  constOnScrollEvent = throttle(this.onScroll, 300);

  handleResize = () => {
    this.setState({ isBannerOverflown: false }); // reset
    this.isBannerOverflown(this.banner.current);
  };

  componentDidMount() {
    if (!this.isScrolledToTop) {
      this.setState({ isFloating: true });
    }
    this.isBannerOverflown(this.banner.current);

    window.addEventListener('scroll', this.constOnScrollEvent);
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.constOnScrollEvent);
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const menuItems = this.props.items;
    const { isOpen, isFloating, dropdown, isBannerOverflown } = this.state;

    const menuClassName = classNames('Navbar__menu', {
      'Navbar__menu--open': isOpen,
    });
    const bannerClassName = classNames('Navbar__banner', {
      'Navbar__banner--isOverflow': isBannerOverflown,
    });

    return (
      <nav className="Navbar js-navbar" role="navigation" aria-label="main-navigation">
        {this.props.banner?.visible &&
          <div className={bannerClassName} ref={this.banner}>
            <div className="Navbar__banner__inner">
              {this.props.banner?.link
                ? (
                  //<a href='/xebia' target="_blank" rel="noopener noreferrer">
                  <a href={this.props.banner.link} rel="noopener noreferrer">
                    {this.props.banner?.text}
                  </a>
                )
                : this.props.banner?.text
              }
            </div>
          </div>
        }

        <div className="Navbar__container">
          <div className={menuClassName}>
            {menuItems && menuItems.map((item) => (
              <div className="Navbar__item" key={item.label}>
                {item.dropdown && item.dropdown.length > 0
                  ? (
                    <div
                      className={classNames('', {
                        'Navbar__item__btn--open': dropdown[item.label]
                      })}
                      onClick={() => this.toggleDropdown(item.label)}
                    >
                      <Button
                        variants={['text']}
                        className="Navbar__item__btn"
                        activeClassName="Navbar__item--active"
                        to={item.to}
                      >
                        {item.label}
                      </Button>
                      <div className="Navbar__item__btn__arrow">
                        <img src={IconArrowGreenDown} alt="icon arrow" className="" />
                      </div>
                    </div>
                  )
                  : (
                    <Button
                      variants={['text']}
                      className="Navbar__item__btn"
                      activeClassName="Navbar__item--active"
                      to={item.to}
                    >
                      {item.label}
                    </Button>
                  )
                }

                {item.dropdown && item.dropdown.length > 0 &&
                  <div className="Navbar__item__dropdown">
                    {item.dropdown.map((e) =>
                      <Button
                        key={e.label}
                        variants={['text']}
                        className="Navbar__item__dropdownItem"
                        to={e.to}
                      >
                        {e.label}
                      </Button>
                    )}
                  </div>
                }
              </div>
            ))}

            <Button className="Navbar__cta" to="/mlops-data-platform-streaming-analytics-data-driven" >
              FREE CONSULTATION
            </Button>
            {/* <Link to="/consultation" className="Navbar__cta">
              FREE CONSULTATION
            </Link> */}
          </div>

          <Link to={'/'} className="Navbar__logo-wrapper" title="Logo">
            <img src={LogoSrc} alt="logo" className="Navbar__logo Navbar__logo--full" />
            <img src={LogoSignetSrc} alt="logo signet" className="Navbar__logo Navbar__logo--signet" />
          </Link>

          <Burger
            className={'Navbar__burger'}
            onClick={this.toggleMenu}
            isOpen={isOpen}
          />
        </div>
      </nav>
    );
  }
}

export default Navbar;
